import React, { useState, useEffect, useContext } from 'react';
import { useTheme } from '../context/ThemeContext.js';
import { usePersistentState } from '../utils';
import { NecttosContext } from '../context/NecttosContext';
import Cookies from 'js-cookie';
import Button from './Button/Button.tsx';

const SettingsPage = ({ onClose }) => {
	const { theme: mode, toggleTheme: toggleDarkMode } = useTheme();

	const { setDashboard, dashboard } = useContext(NecttosContext);
	const handleLogout = () => {
		localStorage.clear();
		Cookies.remove('userToken');
		window.location.href = '/';
		window.location.reload(true);
	};

	const toggleTheme = (id) => {
		setDashboard(id);
		localStorage.removeItem('homePage');
		window.location.reload();
	};
	const clearAllCache = () => {
		localStorage.clear();
		window.location.href = '/';
		window.location.reload(true);
	};

	return (
		<div className={`flex flex-col h-full bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-white ${onClose && 'absolute w-full'}`}>
			<div className='p-4 bg-gray-200 dark:bg-gray-900 flex justify-between items-center'>
				<h2 className='text-2xl font-semibold'>Settings</h2>
				{onClose && (
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				)}
			</div>

			{/* Theme Selection */}
			<div className='p-4 space-y-4'>
				<div className='flex justify-between items-center'>
					<span className='text-lg'>Theme</span>
					<div className='flex space-x-4'>
						<button onClick={() => toggleTheme('primary')} className='bg-blue-500 text-white py-2 px-4 rounded-full' style={dashboard == 'primary' ? { backgroundColor: 'green' } : {}}>
							Primary Theme
						</button>
						<button onClick={() => toggleTheme('secondary')} className='bg-blue-500 text-white py-2 px-4 rounded-full' style={dashboard == 'secondary' ? { backgroundColor: 'green' } : {}}>
							Secondary Theme
						</button>
					</div>
				</div>

				{/* Dark Mode Toggle */}
				<div className='flex justify-between items-center'>
					<span className='text-lg'>Dark Mode</span>
					<button onClick={toggleDarkMode} className='bg-blue-500 text-white py-2 px-4 rounded-full'>
						{mode == 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
					</button>
				</div>

				<div className='flex justify-between items-center'>
					<span className='text-lg'>Log Out</span>
					<button onClick={handleLogout} className='bg-blue-500 text-white py-2 px-4 rounded-full'>
						Logout
					</button>
				</div>
				<div className='flex justify-between items-center'>
					<span className='text-lg'>Clear All Cache</span>
					<button onClick={clearAllCache} className='bg-blue-500 text-white py-2 px-4 rounded-full'>
						Clear All Cache
					</button>
				</div>
			</div>
		</div>
	);
};

export default SettingsPage;
